import {
  getAdminV1StoresStoreIdAuctionsQuestions,
  postAdminV1StoresStoreIdAuctionsQuestionsIdAnswer,
  postAdminV1StoresStoreIdAuctionsQuestionsIdHide,
  type AdminAuctionQuestion,
  type GetAdminV1StoresStoreIdAuctionsQuestions200,
  type GetAdminV1StoresStoreIdAuctionsQuestionsParams,
} from '@nucleus-commerce/api-client/admin';

export type QuestionListParams = GetAdminV1StoresStoreIdAuctionsQuestionsParams;

/**
 * Shopper questions on lots (D-180). A question is private until it is answered; an answer
 * publishes it on the lot page and emails the asker. Hiding removes it from the queue and the
 * lot page without an answer.
 */
export const questionsApi = {
  list: (
    storeId: string,
    params: QuestionListParams,
  ): Promise<GetAdminV1StoresStoreIdAuctionsQuestions200> =>
    getAdminV1StoresStoreIdAuctionsQuestions({ storeId }, params),
  answer: (storeId: string, id: string, answer: string): Promise<AdminAuctionQuestion> =>
    postAdminV1StoresStoreIdAuctionsQuestionsIdAnswer({ storeId, id }, { answer }),
  hide: (storeId: string, id: string, reason: string): Promise<AdminAuctionQuestion> =>
    postAdminV1StoresStoreIdAuctionsQuestionsIdHide({ storeId, id }, { reason }),
};
